<template>
  <li
    :class="{ 'active' : isActiveSnb, 'open' : isOpenLnb }"
    ref="snbItem">
    <button v-if="isHasLnb || snbMenu.disabled" class="link_snb" @click="onClickSnb()" :disabled="snbMenu.disabled">
      <span class="icon_menu">{{ snbMenu.menuIcon }}</span>
      <span class="txt_menu">{{ snbMenu.title }}</span>
    </button>
    <router-link v-else :to="{name : snbMenu.routerPath }" class="link_snb">
      <span class="icon_menu">{{ snbMenu.menuIcon }}</span>
      <span class="txt_menu">{{ snbMenu.title }}</span>
    </router-link>
    <div v-if="isHasLnb" class="lnb_lemontree">
      <ul class="list_lnb">
        <LnbItem
          v-for="lnbMenu in snbMenu.menuList"
          :key="lnbMenu.title"
          :lnbMenu="lnbMenu"/>
      </ul>
    </div>
  </li>
</template>

<script>
import LnbItem from './LnbItem'
import { mapActions } from 'vuex';

export default {
  name:'SnbItem',
  props:{
    serviceId: String,
    snbMenu: Object
  },
  components:{
    LnbItem
  },
  data(){
    return{
      isOpenLnb: false
    }
  },
  computed:{
    isHasLnb(){
      return Boolean(this.snbMenu.menuList && this.snbMenu.menuList.length > 0)
    },
    isActiveSnb(){
      if(!this.$route.meta.snbMenuData) return false;
      const isServiceId = this.$route.meta.menuData.id === this.serviceId
      const isSnbMenuId = this.$route.meta.snbMenuData.id === this.snbMenu.id
      return isServiceId && isSnbMenuId;
    },
  },
  methods:{
    ...mapActions('commonGnb', [ 'fetchGnbAction' ]),
    onClickSnb(){
      this.isOpenLnb = !this.isOpenLnb;
      this.fetchGnbAction(true);
    }
  }
}
</script>
<style lang="scss" scoped>
.snb_lemontree .list_snb .link_snb{display:block;width:100%;padding:6px 7px 4px;border-radius:$CONTENT_RADIUS;font-weight:600;font-size:14px;line-height:30px;color:rgba($ACTIVE_TEXT,.6);box-sizing:border-box;text-align:left;transition:background-color 0.1s}

.snb_lemontree .list_snb .icon_menu{display:inline-block;width:26px;height:26px;padding:8px 0 2px;font-size:14px;line-height:16px;vertical-align:top;text-align:center;box-sizing:border-box;opacity:.6}
.snb_lemontree .list_snb .link_snb .txt_menu{margin-left:4px}
.snb_lemontree .list_snb .link_snb:hover{background-color:rgba($TERTIARY_COLOR,.2)}

.snb_lemontree .list_snb .active > .link_snb{background-color:rgba($TERTIARY_COLOR,.8);color:$ACTIVE_TEXT}
.snb_lemontree .list_snb .link_snb:hover{color:$ACTIVE_TEXT}
.snb_lemontree .list_snb .link_snb:hover .icon_menu,
.snb_lemontree .list_snb .active > .link_snb .icon_menu{opacity:1}

/* hover */
/* .snb_lemontree .list_snb .link_snb:hover{position:relative}
.snb_lemontree .list_snb .link_snb:hover .txt_menu{display:block;position:absolute;top:0;left:90%;background-color:#000;color:#fff} */

// disabled
.snb_lemontree .list_snb .link_snb:disabled,
.snb_lemontree .list_snb .link_snb:disabled .icon_menu,
.snb_lemontree .list_snb .link_snb:disabled:hover,
.snb_lemontree .list_snb .link_snb:disabled:hover .icon_menu{opacity:.5;background-color:$DISABLED_BG;color:$DISABLED_TEXT;cursor:default}

.snb_lemontree .list_snb li + li{margin-top:4px}

.active_snb .snb_lemontree .list_snb .open > .lnb_lemontree,
.active_snb .snb_lemontree .list_snb .active > .lnb_lemontree{max-height:1240px}
.active_snb .snb_lemontree .list_snb .link_snb:hover{position:static}
.active_snb .snb_lemontree .list_snb .link_snb:hover .txt_menu{display:inline-block;position:static;background:none;color:inherit}

/* snb - lnb */
.snb_lemontree .lnb_lemontree{overflow:hidden;max-height:0}
.active_snb .lnb_lemontree{transition:0.5s}

@media (prefers-color-scheme: dark) {
  .snb_lemontree .list_snb .link_snb{color:rgba($ACTIVE_TEXT_DARK,.8)}
  // .snb_lemontree .list_snb .active > .link_snb{color:$ACTIVE_TEXT_DARK}
.snb_lemontree .list_snb .active > .link_snb{color:$ACTIVE_TEXT_DARK}
.snb_lemontree .list_snb .link_snb:hover{color:$ACTIVE_TEXT_DARK}

  // disabled
  .snb_lemontree .list_snb .link_snb:disabled,
  .snb_lemontree .list_snb .link_snb:disabled .icon_menu,
  .snb_lemontree .list_snb .link_snb:disabled:hover,
  .snb_lemontree .list_snb .link_snb:disabled:hover .icon_menu{background-color:$DISABLED_BG_DARK;color:$DISABLED_TEXT_DARK}
}
</style>